import { useQuery } from '@tanstack/react-query'
import { Link, useParams } from 'react-router-dom'
import { QueryState } from '../components/QueryState'
import { api } from '../lib/api'

/**
 * 소식 상세.
 *
 * **본문은 plain text다** — 리치 텍스트 에디터를 쓰지 않기로 했으므로(개발 플랜 §6-1)
 * 저장된 값에 HTML이 있을 이유가 없고, React가 문자열을 그대로 이스케이프해 넣는다.
 * `dangerouslySetInnerHTML`을 쓰지 않는 것이 여기서는 기능이 아니라 안전선이다.
 * 줄바꿈만 `white-space: pre-wrap`으로 살린다.
 */
export function BoardDetailPage() {
  const { id } = useParams<{ id: string }>()
  const post = useQuery({
    queryKey: ['post', id],
    queryFn: () => api.post(id ?? ''),
    enabled: Boolean(id),
    // 조회수는 상세를 열 때 서버가 올린다. 재요청마다 올라가는 게 정상이므로
    // 캐시를 오래 붙들지 않는다(뒤로 갔다 오면 최신 수치를 다시 받는다).
    staleTime: 0,
  })

  const p = post.data

  return (
    <>
      {/* 온 곳으로 돌려보낸다 — 헤더가 게시판을 `?board=`로 가르므로(App.tsx MENU) 그냥
          `/board`로 보내면 `이야기`에서 들어온 사람이 전체 목록에 떨어진다.
          아직 글을 못 받았으면 종류를 모르니 전체로 간다. */}
      <Link className="back-link" to={p ? `/board?board=${p.board.key}` : '/board'}>
        ← {p ? `${p.board.label} 목록` : '목록'}
      </Link>
      <QueryState isPending={post.isPending} error={post.error}>
        {p ? (
          <article className="panel">
            <div className="detail-head">
              <div className="card-org">
                <span className="tag">{p.board.label}</span>
                {p.org !== null && p.org.name !== null && (
                  <>
                    {' '}
                    <Link to={`/orgs/${p.org.id}`}>{p.org.name}</Link>
                  </>
                )}
              </div>
              <h1 className="page-title">{p.title}</h1>
              <p className="muted small" style={{ margin: 0 }}>
                {p.publishedAt?.slice(0, 10) ?? ''} · 조회 {p.viewCount}
              </p>
            </div>

            <p style={{ whiteSpace: 'pre-wrap' }}>{p.body}</p>

            {p.images.length > 0 && (
              <div className="post-images">
                {p.images.map((img) => (
                  // alt는 비어 있을 수 있다. 그때 `alt=""`로 두면 스크린리더가 장식으로 보고
                  // 건너뛴다 — 설명 없는 이미지를 파일명으로 읽어주는 것보다 낫다.
                  <img key={img.id} src={img.url} alt={img.altText ?? ''} loading="lazy" />
                ))}
              </div>
            )}
          </article>
        ) : null}
      </QueryState>
    </>
  )
}
